import React from 'react';
import ScheduledAgents from '../../../ScheduledAgents';

const SECTIONS = [
  {
    label: 'Scheduled Runners',
    value: 'scheduledAgents',
    component: <ScheduledAgents />
  }
];

export default SECTIONS;
